/*jshint esversion: 6 */

import React from 'react';
import CaBadgeView from "../general/CaBadgeView";

const CaProfileBadgesView = (props)=> {
    const {badges, body} = props;
    return(
        <div className={"ProfileBadges ProfilePageBlock"}>
            <div className={"ProfileBadges__content"}>
                <h2 className={"ProfileBadges__header"}>Badges</h2>
                {badges.length==0 && <p className={"ProfileBadges__body"}>{body}</p> }
                <div className={"ProfileBadges__inner"}>
                    <div className={"ProfileBadges__list"}>
                        { badges.map((badge,i)=>(
                            <CaBadgeView
                                key={i}
                                classNamePrepend    ={"ProfileBadges__badge"}
                                badgeImg            ={badge.badgeImg}
                                badgeName           ={badge.badgeName}
                                badgeDescription    ={badge.badgeDescription}
                            />
                        ))}
                    </div>
                </div>
                <div className={"ProfilePageDivider"}></div>
            </div>
        </div>
    )
};

export default CaProfileBadgesView;




